(function() {
    'use strict';

    angular
        .module('quantixApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            }
            
        });
        
        $stateProvider.state('notFound', {
        	parent: 'app',
        	url: '/notFound',
        	data: {
        		authorities: []
        	},
        	views: {
        		'content@': {
        			templateUrl: 'app/home/404.html',
        			controller: 'HomeController',
        			controllerAs: 'vm'
        		}
        	}
        });

        $stateProvider.state('forbidden', {
        	parent: 'app',
        	url: '/forbidden/:modulename', 
        	data: {
        		authorities: []
        	},
        	views: {
        		'content@': {
        			templateUrl: 'app/home/forbidden.html',
        			controller: 'HomeController',
        			controllerAs: 'vm'
        		}
        	}
        });
        $stateProvider.state('forbiddenDetails', {
        	parent: 'app',
        	url: '/forbiddenDetail/:modulename', 
        	data: {
        		authorities: []
        	},
        	params : {
             	companyCode : null ,
             	sectionId : null,
             	companyCodeToview : null,
             	companyName : null
 			},
        	views: {
        		'content@': {
        			templateUrl: 'app/home/forbiddenDetail.html',
        			controller: 'HomeController',
        			controllerAs: 'vm'
        		}
        	}
        });
        $stateProvider.state('forbiddenDetailsForPortfolio', {
        	parent: 'app',
        	url: '/forbiddenDetailsForPortfolio/:modulename', 
        	data: {
        		authorities: []
        	},
        	params : {
        		portfolioId : null ,
        		portfolioName : null,
        		portfolioType : null,
        		portfolioDateTime:null
 			},
        	views: {
        		'content@': {
        			templateUrl: 'app/home/forbiddenDetailsForPortfolio.html',
        			controller: 'HomeController',
        			controllerAs: 'vm'
        		}
        	}
        });
        
        $stateProvider.state('serviceUnavailable', {
        	parent: 'app',
        	url: '/serviceUnavailable',
        	data: {
        		authorities: []
        	},
        	views: {
        		'content@': {
        			templateUrl: 'app/home/serviceUnavailable.html',
        			controller: 'HomeController',
        			controllerAs: 'vm'
        		}
        	}
        });
    }
})();
